export default theme => ({
  highlighted_part: {
    fontWeight: 500,
  },
  part: {
    fontWeight: 300,
  },
});
